module.exports = __webpack_public_path__ + "assets/img/commission3@2x.926d57c1.png";